import { render } from "./PageComponent.vue?vue&type=template&id=7b4052ef&scoped=true"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import "./PageComponent.vue?vue&type=style&index=0&id=7b4052ef&scoped=true&lang=css"

import exportComponent from "D:\\Programas\\laragon\\www\\projects\\vuejs\\adivina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4052ef"]])

export default __exports__